angular
  .module 'shared'
  .directive 'waiverEzidebitBankAccountPaymentDetails', ->
    restrict: 'E'
    scope:
      waiver: '='
      walletDetails: '='
      publicKey: '='
      pageParams: '='
      saveWaiver: '&'
    template: require('templates/shared/waivers/payment_details/waiver_ezidebit_bank_account.html.slim')
    controller: (
      $scope,
      $rootScope,
      $timeout,
      $document,
      loadingAnimation,
      EzidebitService
    ) ->
      endpoint = $scope.waiver.ezidebit_public_url

      signedWaiverWalletDetail = $scope.waiver.signed_waiver_wallet_detail_attributes
      isCustomerExist = signedWaiverWalletDetail.customer_ref && signedWaiverWalletDetail.active_on_ezidebit

      $scope.customerReference = EzidebitService.getCustomerReference(
        gymId: $rootScope.gym?.id || window.DATA.gym_id,
        contactId: $scope.waiver.signed_waiver_contacts_attributes[0]?.contact_id,
        context: 'SW'
      )

      initSaveCustomer = ->
        $timeout ->
          params =
            submitAction: 'SaveCustomerAccount'
            submitButton: 'submitBankAccount'
            submitCallback: onSaveSuccess
            submitError: onError
            customerFirstName: 'firstName'
            customerLastName: 'lastName'
            accountName: 'accountName'
            accountBSB: 'bsb'
            accountNumber: 'accountNumber'
            customerEmail: 'customerEmail'
            customerMobile: 'customerMobile'
            customerReference: 'customerReference'

          window.initEziDebit()
          eziDebit.init $scope.publicKey, params, endpoint

      initUpdateCustomer = ->
        $timeout ->
          params =
            submitAction: 'ChangeCustomerPaymentInfo'
            submitButton: 'updateBankAccount'
            submitCallback: onUpdateSuccess
            submitError: onError
            accountName: 'accountName'
            accountBSB: 'bsb'
            accountNumber: 'accountNumber'
            customerRef: 'customerRef'

          window.initEziDebit()
          eziDebit.init $scope.publicKey, params, endpoint

      init = () ->
        if isCustomerExist
          initUpdateCustomer()
        else
          initSaveCustomer()

      $scope.$watch 'publicKey', (key) ->
        init() if key

      onSaveSuccess = (response) ->
        $scope.walletDetails.error =  undefined
        $scope.waiver.signed_waiver_wallet_detail_attributes =
          angular.extend(
            $scope.waiver.signed_waiver_wallet_detail_attributes,
            getBankAccountDetail(),
            {customer_ref: response.Data.CustomerRef}
          )
        $scope.saveWaiver()

      onUpdateSuccess = (response) ->
        $scope.walletDetails.error =  undefined
        $scope.waiver.signed_waiver_wallet_detail_attributes =
          angular.extend(
            $scope.waiver.signed_waiver_wallet_detail_attributes,
            getBankAccountDetail()
          )
        $scope.saveWaiver()

      getBankAccountDetail = ->
        payment_method: 'bank_account'
        payment_provider: 'ezidebit'
        last4: $scope.walletDetails.accountNumber.substr(-4)
        bsb: $scope.walletDetails.bsb
        full_name: $scope.walletDetails.accountName
        exp_month: undefined
        exp_year: undefined

      onError = (error) ->
        $timeout ->
          $scope.pageParams.isLoading = false
          loadingAnimation.hide()
          $scope.walletDetails.error = error
          $document.scrollToElementAnimated(angular.element('#walletDetails'))

      $scope.onBsbChange = ->
        $scope.walletDetails.bsb =
          $scope.walletDetails.bsb?.replace(/[^0-9]/g, '')
